import { Link } from "react-router-dom";
import { Facebook, Instagram, Twitter, Linkedin, Phone, Mail, MapPin, Clock } from "lucide-react";
import { BUSINESS, CATEGORIES, SERVICES } from "@/lib/constants";

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid gap-10 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-600 to-blue-400 grid place-items-center text-white font-heading font-bold">S</div>
            <div className="font-heading font-bold text-white text-lg">SSB Copier</div>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">
            Your trusted partner for CCTV, computers, laptops, printers & professional IT services since 2010.
          </p>
          <div className="mt-5 flex gap-3">
            <a href={BUSINESS.social.facebook} target="_blank" rel="noreferrer" className="w-9 h-9 grid place-items-center rounded-full bg-slate-900 hover:bg-blue-900 transition" data-testid="footer-facebook"><Facebook className="w-4 h-4" /></a>
            <a href={BUSINESS.social.instagram} target="_blank" rel="noreferrer" className="w-9 h-9 grid place-items-center rounded-full bg-slate-900 hover:bg-blue-900 transition" data-testid="footer-instagram"><Instagram className="w-4 h-4" /></a>
            <a href={BUSINESS.social.twitter} target="_blank" rel="noreferrer" className="w-9 h-9 grid place-items-center rounded-full bg-slate-900 hover:bg-blue-900 transition" data-testid="footer-twitter"><Twitter className="w-4 h-4" /></a>
            <a href={BUSINESS.social.linkedin} target="_blank" rel="noreferrer" className="w-9 h-9 grid place-items-center rounded-full bg-slate-900 hover:bg-blue-900 transition" data-testid="footer-linkedin"><Linkedin className="w-4 h-4" /></a>
          </div>
        </div>

        <div>
          <h4 className="text-white font-heading font-semibold mb-4">Shop</h4>
          <ul className="space-y-2 text-sm">
            {CATEGORIES.slice(0, 7).map((c) => (
              <li key={c.slug}><Link to={`/products?category=${encodeURIComponent(c.slug)}`} className="text-slate-400 hover:text-white">{c.name}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-heading font-semibold mb-4">Services</h4>
          <ul className="space-y-2 text-sm">
            {SERVICES.map((s) => (
              <li key={s.slug}><Link to={`/services#${s.slug}`} className="text-slate-400 hover:text-white">{s.title}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-heading font-semibold mb-4">Reach Us</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li className="flex gap-3"><MapPin className="w-4 h-4 shrink-0 mt-0.5 text-blue-400" /> {BUSINESS.address}</li>
            <li className="flex gap-3"><Phone className="w-4 h-4 shrink-0 mt-0.5 text-blue-400" /> {BUSINESS.phone}</li>
            <li className="flex gap-3"><Mail className="w-4 h-4 shrink-0 mt-0.5 text-blue-400" /> {BUSINESS.email}</li>
            <li className="flex gap-3"><Clock className="w-4 h-4 shrink-0 mt-0.5 text-blue-400" /> {BUSINESS.hours}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-900">
        <div className="max-w-7xl mx-auto px-4 py-5 text-xs text-slate-500 flex flex-wrap items-center justify-between gap-2">
          <div>© {new Date().getFullYear()} SSB Copier. All rights reserved.</div>
          <div className="flex gap-4">
            <Link to="/about" className="hover:text-slate-300">About</Link>
            <Link to="/contact" className="hover:text-slate-300">Contact</Link>
            <Link to="/services" className="hover:text-slate-300">Services</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
